import { lazy } from 'react';
import { authRoles } from 'app/auth';

import MasterServicesLayout from './layouts/MasterServicesLayout';
import MasterServiceDetailsLayout from './layouts/MasterServiceDetailsLayout';
import MasterServiceCategoryDetailsLayout from './layouts/MasterServiceCategoryDetailsLayout';
import MasterServiceGuard from './guards/MasterServiceGuard';
import MasterServiceCategoryGuard from './guards/MasterServiceCategoryGuard';
import MasterServiceProvider from './context/MasterServiceContext';

const MasterServicesPage = lazy(() => import('./use-cases/MasterServicesPage'));
const MasterServicesCreatePage = lazy(() => import('./use-cases/MasterServiceCreatePage'));
const MasterServicesSettingsPage = lazy(() => import('./use-cases/MasterServiceSettings'));
const MasterServiceContentPage = lazy(() => import('./use-cases/MasterServiceContent'));
const MasterServiceCategoriesPage = lazy(() => import('./use-cases/MasterServiceCategories'));
const MasterServiceCategoryCreatePage = lazy(() =>
  import('./use-cases/MasterServiceCategoryCreatePage')
);
const MasterServiceCategoriesSettingsPage = lazy(() =>
  import('./use-cases/MasterServiceCategoriesSettingsPage')
);

const ServiceCatalogueConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
        },
        topBanner: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'master-services',
      element: (
        <MasterServicesLayout>
          <MasterServicesPage />
        </MasterServicesLayout>
      ),
    },
    {
      path: 'master-services/create',
      element: <MasterServicesCreatePage />,
    },
    {
      path: 'master-services/categories',
      element: (
        <MasterServicesLayout>
          <MasterServiceCategoriesPage />
        </MasterServicesLayout>
      ),
    },
    {
      path: 'master-services/categories/create',
      element: <MasterServiceCategoryCreatePage />,
    },
    {
      path: 'master-services/categories/:categoryId/settings',
      element: (
        <MasterServiceCategoryGuard>
          <MasterServiceCategoryDetailsLayout>
            <MasterServiceCategoriesSettingsPage />
          </MasterServiceCategoryDetailsLayout>
        </MasterServiceCategoryGuard>
      ),
    },
    {
      path: 'master-services/categories/:categoryId/content',
      element: (
        <MasterServiceCategoryGuard>
          <MasterServiceCategoryDetailsLayout>
            <div>Category content</div>
            {/* <MasterServiceCategoriesContentPage /> */}
          </MasterServiceCategoryDetailsLayout>
        </MasterServiceCategoryGuard>
      ),
    },
    {
      path: 'master-services/:masterServiceId/settings',
      element: (
        <MasterServiceGuard>
          <MasterServiceProvider>
            <MasterServiceDetailsLayout>
              <MasterServicesSettingsPage />
            </MasterServiceDetailsLayout>
          </MasterServiceProvider>
        </MasterServiceGuard>
      ),
    },
    {
      path: 'master-services/:masterServiceId/content',
      element: (
        <MasterServiceGuard>
          <MasterServiceProvider>
            <MasterServiceDetailsLayout>
              <MasterServiceContentPage />
            </MasterServiceDetailsLayout>
          </MasterServiceProvider>
        </MasterServiceGuard>
      ),
    },
  ],
};

export default ServiceCatalogueConfig;
